module.exports = __webpack_public_path__ + "img/Group-39-Copy.8c3cc593.png";